import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  cursor: default;
  flex-shrink: 0;
  pointer-events: none; /* Allow clicks/hovers to pass through to content below */
`;

export const HeaderIconContainer = styled.div`
  display: inline-flex;
  width: fit-content;
  padding: 10px 0 20px;

  pointer-events: auto; /* Re-enable pointer events for the icon itself */

  svg {
    color: ${({ theme }) => theme.color.chatPanel};
  }
`;
